import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { cached } from '@glimmer/tracking';
import type { PreferredRateOnboardingOption } from 'lumen/components/hotel/wizards/preferred-rate-onboarding/preferred-rate-onboarding-options';
import type HotelWizardsPreferredRateOnboardingRoute from 'lumen/routes/hotel/wizards/preferred-rate-onboarding';
import {
  RATE_TYPE_TO_TRANSLATION_KEYS,
  RATE_TYPES_ICONS,
} from 'lumen/utils/constants/pricing-assistant-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelWizardsPreferredRateOnboardingRateTypeController extends Controller {
  declare model: ModelFrom<HotelWizardsPreferredRateOnboardingRoute>;

  @service declare intl: Services['intl'];
  @service declare router: Services['router'];
  @service('wizards/preferred-rate-onboarding')
  declare wizardsPreferredRateOnboarding: Services['wizards/preferred-rate-onboarding'];

  @cached
  get rateTypeOptions(): PreferredRateOnboardingOption[] {
    const rateTypes =
      this.model.requestPricingAssistantRatePreferencesOptionsTaskResult.value
        ?.rateType ?? [];

    return rateTypes.map((rateType) => {
      const translationKey = RATE_TYPE_TO_TRANSLATION_KEYS[rateType];
      return {
        id: rateType,
        label: translationKey ? this.intl.t(translationKey) : rateType,
        icon: RATE_TYPES_ICONS[rateType],
        isChecked:
          rateType === this.wizardsPreferredRateOnboarding.selectedRateTypeId,
      };
    });
  }

  @action onContinue(): void {
    this.router.transitionTo(
      'hotel.wizards.preferred-rate-onboarding.room-type',
    );
  }

  @action onSkip(): void {
    this.router.transitionTo('hotel.pricing-manager');
  }

  @action
  updateSelectedRateType(value: PreferredRateOnboardingOption): void {
    this.wizardsPreferredRateOnboarding.updateRateType(value.id);
  }
}
